import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

import firebase from "../../node_modules/firebase/compat/app"
import '../../node_modules/firebase/compat/firestore';
import { firebaseConfig } from "../firebase-config";

import NavbarDefault from "./components/navbarDefault";
import FooterDefault from "./components/footerDefault";

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function TicketStatus() {
  const {id} = useParams();

  const [singleDoc,setSingleDoc]=useState({});

  useEffect(()=>{
    async function fetchStatus(){
      // Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      const db = firebase.firestore();
      
      db.collection("tickets")
    
      .doc(id)
      .get()
      .then((snapshot)=>{
        if(snapshot){
          setSingleDoc(snapshot.data());
        }
      });
      console.log(singleDoc);
    }
   fetchStatus();
  }, []);
  

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth={false} disableGutters>
        <Box>
          <NavbarDefault /> 
          <Box style={{ display:'flex', justifyContent:'center' }}>
            <Grid sx={{my:20}}>
              <Card sx={{boxShadow:5, mb:3}} style={{ minWidth: 500, maxWidth:500, minHeight: 350, padding: "10px 10px", margin: "0 auto", justifyContent:'center' }}>
                <CardContent>
                  <Typography fontWeight="bold" component="h1" variant="h5" align="center" sx={{ mt: 1, mb: 3 }} fontFamily="Segoe UI">
                    TICKET STATUS
                  </Typography>
                  <Typography variant="body1" gutterBottom><b>Status:</b> {singleDoc.status}</Typography> 
                  <Typography variant="body1" gutterBottom><b>Email:</b> {singleDoc.email}</Typography> 
                  <Typography variant="body1" gutterBottom><b>Name:</b> {singleDoc.firstname} {singleDoc.lastname}</Typography>
                  <Typography sx={{ mt: 3, mb:1}} fontWeight="bold">Ticket Information:</Typography>
                  <Typography  sx={{mb:1}}><b>Topic</b>: {singleDoc.helptopic}</Typography>
                  <Typography sx={{ mb: 4 }} variant="body1" gutterBottom>{singleDoc.helpdetails}</Typography>
                  <Divider variant="middle" hidden={singleDoc.status === "Resolved" ? false : true}/>
                  <Typography sx={{ mt: 3 }} variant="body1" gutterBottom align="center" fontWeight="bold">{singleDoc.status==="Resolved" ? "Your ticket has been responded to." : ""}</Typography>
                  <Typography component="h1" variant="caption" align="center">{singleDoc.status==="Resolved" ? "Please check your email for more details." : ""}</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Box>  
          <FooterDefault /> 
        </Box>
      </Container>
    </ThemeProvider>
  )
}

export default TicketStatus